import { Spinner } from "react-bootstrap";

const CommonLoader = ({ isLoading, children }) => {
  return isLoading ? (
    <div className="d-flex justify-content-center align-items-center vh-100">
      <Spinner animation="border" role="status" variant="primary" className="custom-spinner">
      </Spinner>
    </div>
  ) : (
    children
  );
};

export default CommonLoader;
